import { Component, Input } from '@angular/core';
import { DataModalComponent } from 'src/app/components/modal/data-modal/data-modal.component';
import { ModalService } from 'src/app/components/modal/modal.service';

@Component({
    selector: 'app-ta-type-multischedule',
    templateUrl: './ta-type-multischedule.component.html',
    styleUrls: ['./ta-type-multischedule.component.scss'],
})
export class TaTypeMultischeduleComponent {
    @Input() data: any;

    stringOfWords: any;

    headers: any = [];

    modalData: any;

    newData: any;

    constructor(private modal: ModalService) {}

    ngOnInit() {
        console.log('DATA RECEIVED', this.data);
        this.headers = Object.keys(this.data.data);
        console.log('NEW DATA', this.data);
        this.modalData = JSON.stringify(this.data.data);

        let count = 100;
        this.stringOfWords = '';
        if (this.headers.length > 0) {
            for (const char of this.modalData) {
                if (count > 0) {
                    count = count - 1;
                    this.stringOfWords += char;
                } else {
                    break;
                }
            }
        }
        console.log(this.stringOfWords);
    }

    ngOnChanges() {
        console.log('DATA RECEIVED On Changes', this.data);
        this.data = {
            pageType: 'scheduleItems',
            data: this.data,
        };
    }

    showModal() {
        this.modal.openModal({
            component: DataModalComponent,
            data: this.data,
            prefix: 'audit-table-data',
        });
    }
}
